import api from "@/lib/api";

let countriesCache = null;
let countriesPromise = null;
const citiesCache = {};

export async function fetchCountries() {
  if (countriesCache) return countriesCache;
  if (!countriesPromise) {
    countriesPromise = api.get("/locations/countries").then((res) => {
      countriesCache = res.data.map((c) => ({ value: c.iso_code, label: c.name, flag: c.flag, phonecode: c.dial_code }));
      return countriesCache;
    });
  }
  return countriesPromise;
}

export async function fetchCitiesForCountry(countryIsoCode) {
  if (!countryIsoCode) return [];
  if (citiesCache[countryIsoCode]) return citiesCache[countryIsoCode];
  const res = await api.get(`/locations/cities?country_code=${countryIsoCode}`);
  const cities = res.data.map((c) => ({ value: c.name, label: c.name }));
  citiesCache[countryIsoCode] = cities;
  return cities;
}

export async function fetchAllPhoneCodes() {
  const countries = await fetchCountries();
  return countries
    .filter((c) => c.phonecode)
    .map((c) => ({ value: c.value, label: `${c.label} (+${c.phonecode})`, flag: c.flag, dialCode: `+${c.phonecode}` }));
}

export const PROFESSIONS = [
  "Driver", "Technician", "Electrician", "Plumber", "Carpenter", "Mason", "Welder",
  "Cook / Chef", "Cleaner", "Security Guard", "Nurse", "Engineer", "Accountant",
  "Sales Executive", "Manager", "Teacher", "Housemaid", "Waiter", "Mechanic",
  "Painter", "Supervisor", "Fabricator", "HVAC Technician", "Storekeeper",
  "Office Staff", "Labourer", "Steel Fixer", "Scaffolder", "Rigger", "Operator",
  "Other",
].map((p) => ({ value: p, label: p }));
